import { API_URL } from '../../../../../../utils/config';

const LTE_KYC_URL = {
  GET_LTE_KYC_SUBSCRIBERS: `${API_URL}/lte_kyc`,
  UPLOAD_LTE_KYC_URL: `${API_URL}/lte_kyc`,
};

export default LTE_KYC_URL;
